export * from './shared';
export * from './details.component';
